import { getTrackedAttributesString } from './trackingAttributesGenerator';

const formTrackingAttributesInjector = () => {
	window.DDC.dataLayer.events.listener.listen(
		'ddc.form.submission',
		({ element }) => {
			if (element && element.closest('form')) {
				const trackedData = getTrackedAttributesString();
				const financeForm = $(element.closest('form'));
				const trackedDataFormField = financeForm.find(
					'input[name="userSessionData"]'
				);
				if (trackedDataFormField.length) {
					trackedDataFormField.attr('value', trackedData);
				} else {
					financeForm.append(
						`<input type='hidden' name='userSessionData' class='hidden' data-id value=${trackedData}>`
					);
				}
			}
		}
	);
};

export default formTrackingAttributesInjector;
